<template>
    <div style="width:300px;height:220px;position:relative;display:inline-block;text-align: left">
        <div style="position:absolute;left:0px;top:0px;width:200px;display:flex;align-items:center;justify-content:center">
            <span style="font-size:20px;">{{user.hardSkills + user.softSkills}}</span>
            <i class="skill" title="All skills"></i> 
        </div>
                
        <div class="avatar-holder" style="position: relative; height: 200px; width:200px; display: inline-block">
            <svg class="avatar-skill-distribution" viewBox="0 0 200 200" xmlns="http//www.w3.org/2000/svg" style="width:200px;height:200px; position: absolute;left: calc(50% - 100px); top: 0">
                <g>
                    <circle cx="100" cy="100" r="62" fill="transparent" style="stroke:#FB718B;stroke-width: 5px;" />
                    <path :d="avatarArc(100,100,62)" style="stroke:#41C7FF;fill:transparent;stroke-width:5px" />
                </g>
            </svg>
            <div style="overflow: hidden;width: 110px;height: 110px;border:solid 5px #ddd;border-radius:60px;background:#ddd;position:absolute;top: 45px;left: calc(50% - 55px)">
                <a :href="user.avatar" target="_blank">
                    <div style="overflow:hidden;border-radius:50px;width:100px;height:100px">
                    <img :src="user.avatar"
                            alt="User Avatar"
                            onerror="this.src='/static/images/no-avatar.jpg'"
                            style="width: 100px; height:auto; margin: auto" />
                    </div>
                </a>
            </div>
        </div>

        <div style="position:absolute;top:8px;left:180px;text-align: center">
            <div>{{$t("Hard skills")}}</div>
            <div style="background: #FB718B; color: white; padding: 0px 6px; width:72px">{{user.hardSkills}}</div>
            <div style="margin-top:4px">{{$t("Soft skills")}}</div>
            <div style="background: #41C7FF; color: white; padding: 0px 6px; width:72px">{{user.softSkills}}</div>
        </div>
    </div>
</template>

<script>
import i18n from '@root/components/i18n';

export default {
    mixins: [i18n],
    data: function () {
        return {
        }
    },
    props: ["user"],
    created: async function () { 
    },
    methods: {
        avatarArc: function(x0, y0, r) {
        var totalSkills = this.user.softSkills + this.user.hardSkills;
        var angle = totalSkills > 0 ? Math.PI * 2 * this.user.softSkills / totalSkills : 0;
        var dx = -r * Math.sin(angle);
        var dy = r * Math.cos(angle);
        var largeArc = angle >= Math.PI ? "1" : "0";
        return `M ${x0} ${y0 + r} A ${r} ${r} 0 ${ largeArc} 1 ${x0 + dx} ${y0 + dy}`;
    }
    },
}
</script>

<style lang="sass" scoped>

</style>

<i18n>
{
    en: {
    },
    ru: {
        "Soft skills": "Поведенческие",
        "Hard skills": "Специальные",
    }
}
</i18n>